import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, UserPlus, DollarSign, TrendingUp, FileText, Bell, LogOut, X, Calendar } from 'lucide-react';
import logo from '../assets/logo.png';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose }) => {
    const location = useLocation();

    const navItems = [
        { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
        { path: '/leads', icon: UserPlus, label: 'Leads' },
        { path: '/customers', icon: Users, label: 'Customers' },
        { path: '/scheduling', icon: Calendar, label: 'Scheduling' },
        { path: '/financials', icon: DollarSign, label: 'Financials' },
        { path: '/kpi-performance', icon: TrendingUp, label: 'KPI & Performance' },
        { path: '/reports', icon: FileText, label: 'Reports' },
        { path: '/notifications', icon: Bell, label: 'Notifications' },
    ];

    return (
        <>
            {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}
            <div className={`sidebar ${isOpen ? 'open' : ''}`}>
                <div className="sidebar-header">
                    <div className="logo-container">
                        <img src={logo} alt="Safety Driver Training" className="logo-image" />
                        <div className="logo-text">
                            <span className="logo-title">Safety Driver</span>
                            <span className="logo-subtitle">TRAINING</span>
                        </div>
                    </div>
                    {isOpen && (
                        <button className="close-sidebar-btn" onClick={onClose}>
                            <X size={20} />
                        </button>
                    )}
                </div>

                <nav className="sidebar-nav">
                    {navItems.map((item) => {
                        const Icon = item.icon;
                        const isActive = location.pathname === item.path;

                        return (
                            <Link
                                key={item.path}
                                to={item.path}
                                className={`nav-item ${isActive ? 'active' : ''}`}
                                onClick={onClose}
                            >
                                <Icon size={20} />
                                <span>{item.label}</span>
                            </Link>
                        );
                    })}
                </nav>

                <div className="sidebar-footer">
                    <button
                        className="nav-item logout-btn"
                        onClick={() => {
                            const config = window.reactPress || window.rpVars || {};
                            const siteUrl = config.api?.rest_url?.split('/wp-json')[0] || '/';
                            window.location.href = siteUrl;
                        }}
                    >
                        <LogOut size={20} />
                        <span>Logout</span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default Sidebar;
